import { Icon } from '@dixa/lib-shared-habla';
import { SearchUserEnriched } from 'lib-search-types';
import { User } from 'lib-shared-types-api';

import { AwayStatus } from 'apis/presence';
import { PresenceRowSelection } from 'components/presence/components/presenceListItem';
import { PresenceSectionSkeleton } from 'components/presence/components/presenceSectionSkeleton';
import { PresenceSectionWarning } from 'components/presence/components/presenceSectionWarning';
import { StatusPresenceListSections } from 'components/presence/components/statusPresenceListSections';

type LegacyPresenceListSectionsProps = {
  members: SearchUserEnriched[];
  profile: User;
  awayStatuses: AwayStatus[];
  isLoading: boolean;
  selection: PresenceRowSelection;
};

export const LegacyPresenceListSections = ({
  members,
  profile,
  awayStatuses,
  isLoading,
  selection,
}: LegacyPresenceListSectionsProps): JSX.Element => {
  const isEmpty = members.length === 0;

  return isLoading ? (
    <>
      <PresenceSectionSkeleton />
      <PresenceSectionSkeleton />
      <PresenceSectionSkeleton />
    </>
  ) : isEmpty ? (
    <PresenceSectionWarning
      title="There's no one here yet"
      message={
        <>
          You can invite people by clicking on the <Icon name="user-plus" />{' '}
          icon above.
        </>
      }
    />
  ) : (
    <StatusPresenceListSections
      members={members}
      profile={profile}
      awayStatuses={awayStatuses}
      selection={selection}
    />
  );
};
